/* InVogue (Morgan, 11 Oct 2026): tapware grid — one card per design.
   Swatch taps swap the card in place; filters, counts, applied chips, sort and URL state run in the browser. */
(function () {
  function money(cents) {
    var v = cents / 100;
    return '$' + (v % 1 ? v.toFixed(2) : v.toFixed(0)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  var LABELS = {
    type: { basin: 'Basin mixers', wall: 'Wall mixers & sets', shower: 'Showers & shower sets', kitchen: 'Kitchen mixers', 'bathroom-accessories': 'Bathroom accessories', 'wastes-traps': 'Wastes & traps', 'shower-screen-hardware': 'Shower screen hardware', 'door-hardware': 'Door hardware' },
    finish: { 'antique-brass': 'Antique Brass', 'brushed-nickel': 'Brushed Nickel', 'brushed-gun-metal': 'Brushed Gunmetal', chrome: 'Chrome', 'brushed-brass': 'Brushed Brass', 'matte-black': 'Matte Black' },
    height: { short: 'Short basin mixer', tall: 'Tall basin mixer' },
    mount: { bench: 'Bench mount', wall: 'Wall mount', ceiling: 'Ceiling mount' },
    room: { bathroom: 'Bathroom', kitchen: 'Kitchen', doors: 'Doors' },
    price: { '0-150': 'Under $150', '150-300': '$150 – $300', '300-500': '$300 – $500', '500-99999': '$500 and over' },
    avail: { '1': 'In stock' }
  };
  var GROUPS = ['type', 'finish', 'height', 'mount', 'room', 'price', 'avail'];

  function init(root) {
    if (root.dataset.twInit) return;
    root.dataset.twInit = '1';
    var grid = root.querySelector('.inv-tw-grid');
    var form = root.querySelector('[data-inv-tw-filters]');
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.inv-twc'));
    var total = cards.length;
    var countEl = root.querySelector('[data-inv-tw-count]');
    var baseCount = countEl ? countEl.textContent : '';
    var applied = root.querySelector('[data-inv-tw-applied]');
    var empty = root.querySelector('[data-inv-tw-empty]');
    var sortSel = root.querySelector('[data-inv-tw-sort]');

    /* ---------- card swap ---------- */
    function show(card, btn, manual) {
      if (!btn) return;
      card.querySelectorAll('.inv-twc__dot').forEach(function (d) {
        var on = d === btn; d.classList.toggle('is-on', on); d.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var img = card.querySelector('.inv-twc__media img');
      if (img && btn.dataset.img) { img.src = btn.dataset.img; img.srcset = btn.dataset.srcset || ''; }
      card.querySelectorAll('[data-tw-link]').forEach(function (a) { a.href = btn.dataset.url; });
      var fin = card.querySelector('[data-tw-fin]');
      if (fin) fin.innerHTML = btn.dataset.fin + (btn.dataset.avail === '1' ? '' : ' · <span class="inv-twc__sold">Sold out</span>');
      var price = +btn.dataset.price;
      card.querySelector('[data-tw-price]').textContent = money(price);
      var min = Infinity;
      card.querySelectorAll('.inv-twc__dot').forEach(function (d) { if (d !== btn && +d.dataset.price < min) min = +d.dataset.price; });
      var from = card.querySelector('[data-tw-from]');
      if (from) from.textContent = isFinite(min) ? 'Other finishes from ' + money(min) : '';
      var r = card.querySelector('[data-tw-rating]');
      if (r) {
        var rt = parseFloat(btn.dataset.rating || '0');
        r.hidden = !(rt > 0);
        r.querySelector('.inv-twc__stars').style.setProperty('--r', rt || 0);
        r.querySelector('[data-tw-rt]').textContent = rt > 0 ? (btn.dataset.rating + ' (' + (btn.dataset.raters || 0) + ')') : '';
      }
      card.dataset.price = price;
      card.dataset.avail = btn.dataset.avail;
      card.dataset.fin = btn.dataset.fh;
      if (manual) card.dataset.manual = '1';
    }
    cards.forEach(function (card) {
      var on = card.querySelector('.inv-twc__dot.is-on') || card.querySelector('.inv-twc__dot');
      if (on) { card.dataset.price = on.dataset.price; card.dataset.avail = on.dataset.avail; card.dataset.fin = on.dataset.fh; }
      card.addEventListener('click', function (e) {
        var b = e.target.closest('.inv-twc__dot');
        if (!b) return;
        e.preventDefault();
        show(card, b, true);
      });
    });

    /* ---------- filters ---------- */
    function selected() {
      var s = {};
      GROUPS.forEach(function (g) { s[g] = []; });
      if (form) form.querySelectorAll('input:checked').forEach(function (i) { s[i.name].push(i.value); });
      return s;
    }
    function priceFor(card, s) {
      if (s.finish.length) {
        for (var k = 0; k < s.finish.length; k++) {
          var d = card.querySelector('.inv-twc__dot[data-fh="' + s.finish[k] + '"]');
          if (d) return [+d.dataset.price, d.dataset.avail];
        }
      }
      return [+card.dataset.price, card.dataset.avail];
    }
    function matches(card, s, skip) {
      for (var gi = 0; gi < GROUPS.length; gi++) {
        var g = GROUPS[gi], vals = s[g];
        if (g === skip || !vals.length) continue;
        var ok = vals.some(function (v) {
          if (g === 'finish') return (card.dataset.fins || '').split(',').indexOf(v) > -1;
          if (g === 'price') { var pr = priceFor(card, s)[0] / 100, b = v.split('-'); return pr >= +b[0] && pr < +b[1]; }
          if (g === 'avail') return priceFor(card, s)[1] === '1';
          return card.dataset[g] === v;
        });
        if (!ok) return false;
      }
      return true;
    }
    function apply(push) {
      var s = selected(), n = 0;
      cards.forEach(function (card) {
        if (s.finish.length && card.dataset.manual !== '1') {
          for (var k = 0; k < s.finish.length; k++) {
            var d = card.querySelector('.inv-twc__dot[data-fh="' + s.finish[k] + '"]');
            if (d) { show(card, d, false); break; }
          }
        } else if (!s.finish.length && card.dataset.manual !== '1') {
          var def = card.querySelector('.inv-twc__dot[data-fin="' + root.dataset.defaultFinish + '"]');
          if (def && !def.classList.contains('is-on')) show(card, def, false);
        }
        var ok = matches(card, s, null);
        card.hidden = !ok;
        if (ok) n++;
      });
      /* option counts: designs you would see if you added that option */
      if (form) form.querySelectorAll('input').forEach(function (i) {
        var g = i.name, v = i.value, c = 0;
        cards.forEach(function (card) {
          var t = {}; GROUPS.forEach(function (k) { t[k] = s[k]; });
          t[g] = [v];
          if (matches(card, t, null)) c++;
        });
        var el = i.parentNode.querySelector('[data-n]');
        if (el) el.textContent = c;
        i.parentNode.classList.toggle('is-zero', c === 0 && !i.checked);
      });
      var any = GROUPS.some(function (g) { return s[g].length; });
      if (countEl) countEl.textContent = any ? n + ' of ' + total + ' designs' : baseCount;
      if (empty) empty.hidden = n !== 0;
      /* applied chips */
      if (applied) {
        var html = '';
        GROUPS.forEach(function (g) {
          s[g].forEach(function (v) {
            html += '<button type="button" class="inv-tw-chip" data-g="' + g + '" data-v="' + v + '">' + ((LABELS[g] || {})[v] || v) + ' <span aria-hidden="true">✕</span><span class="visually-hidden"> remove filter</span></button>';
          });
        });
        if (html) html += '<button type="button" class="inv-tw-clear" data-inv-tw-clear>Clear all</button>';
        applied.innerHTML = html;
        applied.hidden = !html;
      }
      /* URL state */
      if (push !== false && window.history && history.replaceState) {
        var u = new URL(location.href);
        GROUPS.forEach(function (g) { var k = g === 'type' ? 'cat' : g; u.searchParams.delete(k); if (s[g].length) u.searchParams.set(k, s[g].join(',')); });
        history.replaceState(null, '', u.pathname + (u.search ? u.search : '') + u.hash);
      }
    }
    function clearAll() {
      if (form) form.querySelectorAll('input:checked').forEach(function (i) { i.checked = false; });
      apply();
    }
    if (form) form.addEventListener('change', function () { apply(); });
    root.addEventListener('click', function (e) {
      var chip = e.target.closest('.inv-tw-chip');
      if (chip) {
        var i = form.querySelector('input[name="' + chip.dataset.g + '"][value="' + chip.dataset.v + '"]');
        if (i) { i.checked = false; i.dispatchEvent(new Event('change', { bubbles: true })); }
        return;
      }
      if (e.target.closest('[data-inv-tw-clear]')) clearAll();
    });

    /* ---------- sort ---------- */
    function sort() {
      var mode = sortSel ? sortSel.value : 'pos';
      var arr = cards.slice();
      arr.sort(function (a, b) {
        if (mode === 'price-asc') return (+a.dataset.price) - (+b.dataset.price);
        if (mode === 'price-desc') return (+b.dataset.price) - (+a.dataset.price);
        if (mode === 'name') return a.dataset.name.localeCompare(b.dataset.name);
        return (+a.dataset.pos) - (+b.dataset.pos);
      });
      arr.forEach(function (c) { grid.appendChild(c); });
    }
    if (sortSel) sortSel.addEventListener('change', sort);

    /* ---------- restore from URL ---------- */
    var q = new URLSearchParams(location.search);
    var had = false;
    GROUPS.forEach(function (g) {
      var raw = q.get(g === 'type' ? 'cat' : g);
      if (!raw || !form) return;
      raw.split(',').forEach(function (v) {
        var i = form.querySelector('input[name="' + g + '"][value="' + v + '"]');
        if (i) { i.checked = true; had = true; }
      });
    });
    apply(false);
    if (had) sort();
  }

  function run() { document.querySelectorAll('[data-inv-tw]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
